<template>
    <div class="scancodedetail">
        <div class="scan_code_detail_top">
            <img class="top_img" :src="publicPath + 'statics/images/blockchain/scan-detail-icon.png'" alt="">
            <ul class="scan_code_detail_desc">
                <li><img class="ico1" :src="publicPath + 'statics/images/blockchain/scan-detail-ico1.png'" alt="">防篡改</li>
                <li><img class="ico2" :src="publicPath + 'statics/images/blockchain/scan-detail-ico2.png'" alt="">可溯源</li>
                <li><img class="ico3" :src="publicPath + 'statics/images/blockchain/scan-detail-ico3.png'" alt="">增信</li>
            </ul>
            <div class="descs" v-if="info.first_log">
                <div>首次查询时间<br>{{info.first_log ? info.first_log.created_at : ''}}</div>
                <div>首次查询地点<br>{{info.first_log ? info.first_log.address : ''}}</div>
                <div @click="toRecord">第{{info.total}}次扫码<br>查看详情<img :src="publicPath + 'statics/images/blockchain/scan-detail-ico4.png'" alt="" /></div>
            </div>
        </div>
        <div class="shop_info clearfix" v-if="info.good.tradesman">
            <div class="thumb">
                <van-image width="2rem" height="2rem" fit="cover" :src="info.good.tradesman.thumb?info.good.tradesman.thumb:(publicPath + 'statics/images/default_touxiang.png')" />
            </div>
            <div class="shop_msg">
                <h3>{{ info.good.tradesman.nickname}}</h3>
                <p>{{ info.good.tradesman.data ? info.good.tradesman.data.describe : ''}}</p>
                <div class="clearfix">
                    <div class="shop_btn" @click="toShop">进入店铺</div>
                </div>
            </div>
        </div>
        <div class="identification page_shopdetail">
            <div class="tabs">
                <div :class="'tab ' + (tab_ind == 0 ? 'act' : '')" @click="tab_ind = 0">商品认证信息</div>
                <div :class="'tab ' + (tab_ind == 1 ? 'act' : '')" @click="tab_ind = 1">生产信息认证</div>
                <div class="tab_line" :style="{left: (50 * tab_ind + '%')}">
                    <div class="lin"></div>
                </div>
            </div>
            <!-- 区块链 追溯码 -->
            <div class="trace" :style="{display: (tab_ind == 0 ? 'block' : 'none')}" v-if="goodsDetail">
                <div class="trace_t">区块链追溯码</div>
                <div class="trace_b">{{ goodsDetail ? goodsDetail.blockchain_key : '' }}</div>
            </div>
            <div class="id_title" :style="{display: (tab_ind == 0 ? 'block' : 'none')}">商品认证信息</div>
            <div class="tracecode" :style="{display: (tab_ind == 0 ? 'block' : 'none')}">
                <div class="section">
                    <!-- <div class="cate">商品信息</div> -->
                    <div class="nr" v-if="goodsDetail">
                        <div class="item">
                            <div class="item_l">生产许可证</div>
                            <div class="item_r">已认证</div>
                        </div>
                        <div class="item">
                            <div class="item_l">认证单位</div>
                            <div class="item_r">天津时代记忆</div>
                        </div>
                        <div class="item">
                            <div class="item_l">认证时间</div>
                            <div class="item_r">{{ goodsDetail.lasttime }}</div>
                        </div>
                        <div class="item">
                            <div class="item_l">生产产地</div>
                            <div class="item_r">{{ goodsDetail.place }}</div>
                        </div>
                        <div class="item" v-if="goodsDetail.tradesman">
                            <div class="item_l">生产人员</div>
                            <div class="item_r">{{ goodsDetail.tradesman.nickname }}</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="id_title" :style="{display: (tab_ind == 0 ? 'block' : 'none')}">编辑信息</div>
            <div class="tracecode" :style="{display: (tab_ind == 0 ? 'block' : 'none')}">
                <div class="section" v-if="operatLogs.length != 0">
                    <!-- <div class="cate">编辑信息</div> -->
                    <div class="nr">
                        <div class="item column" v-for="item in operatLogs" :key="item.id">
                            <div class="item_t">{{ item.created_at }}</div>
                            <div class="item_b">
                                <span class="red">{{ item.operator_name }}</span>
                                <span class="">
                                    <span class="" v-if="item.type == 1">进行了商品上架操作</span>
                                    <span class="" v-else>进行了编辑操作</span>
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="id_title" v-if="buyLogs.length != 0" :style="{display: (tab_ind == 1 ? 'block' : 'none')}">购买信息</div>
            <div class="tracecode" v-if="buyLogs.length != 0" :style="{display: (tab_ind == 1 ? 'block' : 'none')}">
                <div class="section" v-if="buyLogs.length != 0">
                    <!-- <div class="cate">购买信息</div> -->
                    <div class="nr">
                        <div class="item column" v-for="item in buyLogs" :key="item.id">
                            <div class="item_t">{{item.orders.pay_at}}</div>
                            <div class="item_b">
                                <span class="red">{{ item.orders.person }}</span>
                                <span class="">购买了该商品</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="id_title" v-if="info.goodproduction && info.goodproduction.productionprocess.length > 0" :style="{display: (tab_ind == 1 ? 'block' : 'none')}">生产信息认证</div>
            <div class="id_list" v-if="info.goodproduction && info.goodproduction.productionprocess.length > 0" :style="{display: (tab_ind == 1 ? 'block' : 'none')}">
                <div class="line"></div>
                <div class="id_item" :style="{background:'url('+ publicPath +'statics/images/blockchain/scan-detail-ico5.png) top left no-repeat'}" v-for="item in info.goodproduction.productionprocess" :key="item.id">
                    <div class="item_l">
                        <p class="time">{{item.production_at}}</p>
                        <p class="desc">{{item.description}}</p>
                    </div>
                    <div class="item_r"><img :src="item.thumb?item.thumb:(publicPath + 'statics/images/default_touxiang.png')" alt=""></div>
                </div>
            </div>
        </div>
        <!-- <iframe id="getPlaceIframe" src="https://restapi.amap.com/v3/geocode/regeo?key=2fadc174d771223e04524b1e762b38e1&location=117.181961,39.0824&poitype=&radius=&extensions=all&batch=true&roadlevel=0" frameborder="0"></iframe> -->
    </div>
</template>

<script>
    import router from '../../../.././router';
    import { LOGOUT, LOGIN } from '../../../.././vuex/mutation_types';
    import PageSearch from '../../../component/search/Index.vue';
    import Vue from 'vue';
    import Bridge from '../../../.././vuex/bridge.js';
    Vue.prototype.$bridge = Bridge;
    var userAgent = navigator.userAgent;

    export default {
        name: 'my-index',
        data() {
            return {
                publicPath: process.env.BASE_URL,
                code: this.$route.query.code,
                goodsId: this.$route.query.goodsId,
                scan_top_bg: { background: "url('" + process.env.BASE_URL + "statics/images/blockchain/scan_top.png') top center no-repeat" },
                token: null,
                addressComponent: null, // 定位获取到的省市信息
                info: {
                    good: {
                        tradesman: {

                        }
                    },
                    goodproduction: {
                        productionprocess: []
                    }

                },
                tab_ind: 0,
                goodsDetail: null, // 商品信息
                token: null,
                goodsId: this.$route.query.goodsId, // 商品id
                operatLogs: [], // 操作记录( 新增记录 && 编辑记录 )
                buyLogs: [], // 购买记录
            };
        },
        created: function () {
            //根据userAgent判断是否在iOSAndroid客户端中
            if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
                this.isClient = true;
                var params = {
                    data: {
                        naviTitle: "追溯码查询",
                        // naviBlackStyle: true,
                        // levitate: true,
                        backColor:'#0072ff'
                    }
                };
                this.$bridge.callhandler('sdjy://navigation/style', params, data => { });
                var memberParams = {
                    data: {
                        notCallLogin: 1
                    }
                };
                //加载用户信息
                this.$bridge.callhandler('sdjy://member/memberInfo', memberParams, data => {
                    console.log(data);
                    if (data.code == 200) {
                        this.token = data.result.token;
                    }
                });
                //注册方法，客户端重新进入页面刷新数据
                this.$bridge.registerhandler('sdjy://common/refreshPage', (data, responseCallback) => {
                    // alert(JSON.stringify(data));
                    responseCallback('refresh success');
                });
            } else {
                this.isClient = false;
                this.token = this.$store.getters.token;
            }
            this.getscancode();
            // 获取数据
            // this.getGoodsDetail()
            // this.getTraceLog()
        },
        mounted: function () { },
        methods: {

            // 调扫码
            getscancode() {
                console.log('1')
                var that = this;
                if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
                    //获取定位信息
                    var params2 = {
                        'data': {
                        }
                    }
                    this.$bridge.callhandler('sdjy://public/getLocationInfo', params2, (data) => {
                        console.log(111111111)
                        console.log(data)
                        var lat = ''
                        var lng = ''
                        if (data.code == 200) {
                            var lat = data.result.latitude
                            var lng = data.result.longitude
                            that.getAddress(lng, lat)
                        } else {
                            that.getData()
                        }
                    })
                } else {
                    // 获取坐标
                    var wxClient = (function () {
                        return navigator.userAgent.toLowerCase().indexOf('micromessenger') !== -1
                    }
                    )();
                    console.log('wxClient:',wxClient)
                    if (wxClient) {
                        that.getData()
                        return
                        wx.getLocation({ // 获取位置有问题 需要配置微信
                            type: 'wgs84', // 默认为wgs84的gps坐标，如果要返回直接给openLocation用的火星坐标，可传入'gcj02'
                            success: function (res) {
                                var latitude = res.latitude; // 纬度，浮点数，范围为90 ~ -90
                                var longitude = res.longitude; // 经度，浮点数，范围为180 ~ -180。
                                var speed = res.speed; // 速度，以米/每秒计
                                var accuracy = res.accuracy; // 位置精度
                                console.log('latitude:',latitude)
                                that.getAddress(longitude, latitude)
                            },
                            fail: function (res) {
                                console.log('fail:')
                                
                            }
                        });
                    } else {
                        console.log('getData:')
                        that.getData()
                    }
                }
            },
            getAddress(lng, lat) {
                var that = this
                console.log('getAddress:')
                $.get('https://restapi.amap.com/v3/geocode/regeo?key=2fadc174d771223e04524b1e762b38e1&location=' + lng + ',' + lat + '&poitype=&radius=1&extensions=base&batch=false&roadlevel=0', function (res) {
                    console.log('getAddress:',res)
                    if (res.infocode == "10000") {
                        that.addressComponent = res.regeocode.addressComponent
                        console.log(that.addressComponent)
                    } 
                    that.getData()
                })
            },
            getData() {
                console.log('this.$route.query:',this.$route.query)
                var that = this
                var address = "-"
                if (that.addressComponent) {
                    address = that.addressComponent.province + that.addressComponent.city
                }
                var code = that.$route.query.code;
                var goodsId = that.$route.query.goodsId;
                var params;
                if ( code ) {
                    params = {
                        address: address,
                        code: code
                    }
                }

                if ( goodsId ) {
                    params = {
                        address: address,
                        good_id: goodsId
                    }
                }
                that.$api.blockchain.production(params).then(res => {
                    console.log(res)
                    if (res.code == 200) {
                        if ( res.result.good ) {
                            
                            that.info = res.result;
                            that.goodsDetail = res.result.good;
                        } else if ( res.result.blockchain.length > 0 ) {
                            
                            that.info.good = res.result.blockchain[0].good;
                            that.goodsDetail = res.result.blockchain[0].good;
                        }
                        
                        var list = res.result.blockchain; // 总记录
                        console.log(list)
                        var addArr = [] // 新增记录
                        var editArr = [] // 编辑记录
                        if (list.length != 0) {
                            for (var i in list) {
                                // 1 新增 2编辑 3售出 ( 其它状态不要 4生产过程)
                                if (list[i].type == 1) {
                                    addArr.push(list[i])
                                } else if (list[i].type == 2) {
                                    editArr.push(list[i])
                                } else if (list[i].type == 3) {
                                    that.buyLogs.push(list[i])
                                }
                            }
                            // 将新增和编辑记录整合
                            that.operatLogs = editArr.concat(addArr)

                            console.log('that.operatLogs',that.operatLogs,that.buyLogs)
                        }
                    }

                })
            },
            toShop() {
                var tradesman = this.info.good.tradesman
                if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
                    var params = {
                        'data': {
                            'url': this.$publicData.clientUrl + '/art/detail?tradesmanId=' + tradesman.id
                        }
                    }
                    this.$bridge.callhandler('sdjy://public/openNewWebView', params, (data) => {

                    })
                } else {
                    this.$router.push({
                        path: '/art/detail',
                        query: {
                            tradesmanId: tradesman.id
                        }
                    })
                }
            },
            toRecord() {
                if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
                    var params = {
                        'data': {
                            'url': this.$publicData.clientUrl + '/chain/scancoderecord?code=' + this.code
                        }
                    }
                    this.$bridge.callhandler('sdjy://public/openNewWebView', params, (data) => {

                    })
                } else {
                    this.$router.push({
                        path: '/chain/scancoderecord',
                        query: {
                            code: this.code
                        }
                    })
                }
            },
            // // 获取商品信息
            // getGoodsDetail() {
            //     var that = this
            //     var params = {
            //         good_id: that.goodsId
            //     }
            //     that.$api.shop.goodsDetail(params).then(res => {
            //         if (res.code == 200) {
            //             that.goodsDetail = res.result
            //         }
            //     })
            // },
            // 获取追溯信息
            getTraceLog() {
                var that = this
                var params = {
                    good_id: that.goodsId
                }
                that.$api.shop.tracecode(params).then(res => {
                    if (res.code == 200) {
                        var list = res.result // 总记录
                        var addArr = [] // 新增记录
                        var editArr = [] // 编辑记录
                        if (list.length != 0) {
                            for (var i in list) {
                                // 1 新增 2编辑 3售出 ( 其它状态不要 4生产过程)
                                if (list[i].type == 1) {
                                    addArr.push(list[i])
                                } else if (list[i].type == 2) {
                                    editArr.push(list[i])
                                } else if (list[i].type == 3) {
                                    that.buyLogs.push(list[i])
                                }
                            }
                            // 将新增和编辑记录整合
                            that.operatLogs = editArr.concat(addArr)
                        }
                    }
                })
            },
        }
    };
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped>
    .scancodedetail {
        width: 10rem;
        min-height: 100vh;
        padding-bottom: .4rem;
        background: rgba(245, 246, 250, 1);
    }

    .scan_code_detail_top {
        width: 10rem;
        height: 7.59rem;
        background: linear-gradient(0deg, #46a1ff, #0072ff);
        overflow: hidden;
    }

    .scan_code_detail_top .top_img {
        width: 4.57rem;
        height: 4.57rem;
        margin: .3rem auto 0 auto;
        display: block;
    }

    .scan_code_detail_desc {
        height: 0.35rem;
        line-height: 0.35rem;
        margin: 0.4rem auto 0.5rem auto;
        font-size: 0.35rem;
        font-family: PingFang SC;
        font-weight: 400;
        color: rgba(0, 0, 0, 0.7);
        text-align: center;
        /* display: flex; */
    }

    .scan_code_detail_desc li {
        height: 0.53rem;
        font-size: 0.32rem;
        font-family: PingFang SC;
        font-weight: 400;
        color: #FFFFFF;
        padding: 0 0.2rem;
        display: inline-block;
    }

    .scan_code_detail_desc li img {
        margin-right: .08rem;
        vertical-align: middle;
    }

    .scan_code_detail_desc .ico1 {
        width: 0.28rem;
        height: 0.33rem;
    }

    .scan_code_detail_desc .ico2 {
        width: 0.33rem;
        height: 0.32rem;
    }

    .scan_code_detail_desc .ico3 {
        width: 0.37rem;
        height: 0.32rem;
    }

    .descs {
        width: 9.2rem;
        margin: 0 auto;
        font-size: 0.35rem;
        font-family: Source Han Sans SC;
        font-weight: 400;
        color: #FFFFFF;
        line-height: 0.57rem;

        display: flex;
    }

    .descs>div {
        /* width:33.33%; */
        padding-left: .44rem;
        flex: 1;
    }

    .descs>div:first-child {
        width: 3.4rem;
        padding-left: .14rem;
        flex: none;
        white-space: nowrap;
    }

    .descs>div>img {
        width: 0.13rem;
        height: 0.25rem;
        vertical-align: middle;
        margin-left: .2rem;
    }

    .shop_info {
        width: 9.2rem;
        height: 2.92rem;
        margin: .4rem auto 0 auto;
        padding: .4rem .32rem;
        background: #FFFFFF;
        border-radius: 0.13rem;
    }

    .shop_info .thumb {
        width: 2rem;
        height: 2rem;
        line-height: 2rem;
        margin: 0 .32rem 0 0;
        background: #1c85ff;
        border-radius: 50%;
        text-align: center;
        float: left;
        overflow: hidden;
    }

    .shop_info .shop_msg {
        width: 6.13rem;
        float: right;
    }

    .shop_info h3 {
        height: 0.42rem;
        line-height: 0.42rem;
        font-size: 0.37rem;
        font-family: PingFang SC;
        font-weight: 400;
        color: #000000;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    .shop_info .shop_msg p {
        height: 0.37rem;
        line-height: 0.37rem;
        margin-top: .21rem;
        font-size: 0.35rem;
        font-family: PingFang SC;
        font-weight: 400;
        color: #000000;
        opacity: 0.54;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    .shop_info .shop_btn {
        width: 2.47rem;
        height: 0.82rem;
        line-height: 0.82rem;
        margin-top: .28rem;
        background: linear-gradient(90deg, #4da9ff, #008eff);
        border-radius: 0.41rem;
        text-align: center;
        font-size: 0.37rem;
        font-family: PingFang SC;
        font-weight: 400;
        color: #FFFFFF;
        float: right;
    }

    .identification {
        width: 9.2rem;
        margin: .3rem auto 0 auto;
        background: #FFFFFF;
        border-radius: 0.13rem;
    }

    .identification .tabs {
        position: relative;
        width: 100%;
        height: 1.04rem;
        border-bottom: .014rem solid rgba(0, 0, 0, 0.12);
        display: block;
    }

    .identification .tabs .tab {
        width: 50%;
        height: 1.04rem;
        line-height: 1.04rem;
        text-align: center;
        color: rgba(0, 0, 0, 0.72);
        float: left;
    }

    .identification .tabs .tab.act {
        color: #008eff;
    }

    .identification .tabs .tab_line {
        position: absolute;
        bottom: 0;
        left: 0;
        width: 50%;
        height: .053rem;
        transition-duration: .3s;
    }

    .identification .tabs .tab_line .lin {
        width: 1.893rem;
        height: .053rem;
        margin: 0 auto;
        background: #008eff;
    }

    .identification .id_title {
        position: relative;
        height: 1.19rem;
        line-height: 1.19rem;
        font-size: 0.37rem;
        font-family: PingFang SC;
        font-weight: 400;
        color: #000000;
    }

    .identification .id_title::before {
        content: "";
        width: 0.08rem;
        height: 0.4rem;
        margin-right: .47rem;
        background: #008eff;
        display: inline-block;
    }

    .identification .id_list {
        position: relative;
        padding-top: .51rem;
        border-top: .01rem solid rgba(12, 2, 5, .12);
        overflow: hidden;
    }

    .identification .id_list .line {
        position: absolute;
        top: .7rem;
        bottom: 0;
        left: .36rem;
        border-left: .01rem dashed #1c85ff;
        z-index: 1;
    }

    .identification .id_list .id_item {
        position: relative;
        margin-left: .21rem;
        margin-bottom: .52rem;
        padding-left: .56rem;
        z-index: 2;
        background-size: .32rem !important;
        display: flex;
    }

    .identification .id_list .id_item:last-child {
        background-color: #fff !important;
        margin-bottom: 0;
        padding-bottom: .52rem;
    }

    .id_item .time {
        height: 0.29rem;
        line-height: 0.29rem;
        font-size: 0.29rem;
        font-family: PingFang SC;
        font-weight: 400;
        color: #000000;
        opacity: 0.87;
    }

    .id_item .desc {
        width: 3.92rem;
        margin-top: .13rem;
        font-size: 0.32rem;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #000000;
        line-height: 0.48rem;
    }

    .id_item .item_r {
        margin-left: .47rem;
    }

    .id_item .item_r,
    .id_item .item_r img {
        width: 3.73rem;
        height: 2.13rem;
    }

    .tracecode .section .item_r {
        width:6rem;
    }

    .tracecode .section .item .red {
        color:#1c85ff;
    }
    
</style>